export default {
  /*
  offer type Settings
  */
  entry_id: {
    required: "Please enter Entry ID",
  },
  entry_description: {
    required: "Please enter Entry Description",
  },
  screentype_description: {
    required: "Please enter Screen Type Description",
  },
  campaign_name: {
    required: "Please enter Campaign Name ",
  },
  campaign_type: {
    required: "Please select Campaign Type ",
  },
  campaign_audience: {
    required: "Please select Campaign Audience ",
  },
  segment_name: {
    required: "Please enter Segment Name ",
  },
  segment_type: {
    required: "Please enter Segment Type ",
  },
  selectmarketing_type: {
    required: "Please select Marketing type.",
  },
  institution_name: {
    required: "Please enter Institution name ",
    regex: "Only Alphabets, numbers ,hyphen and spaces are allowed ",
  },
  movie_unique_identifier: {
    required: "Please enter movie unique id.",
    regex: "Spaces are not allowed.",
  },
  uuid: {
    regex: "Spaces are not allowed.",
  },
  ot_offer_type: {
    required: "Please enter offer type ",
    regex: "Only Alphabets, numbers ,% and spaces are allowed ",
  },
  bank_name: {
    required: "Please enter bank name ",
    regex: "Only Alphabets and spaces are allowed ",
  },
  card_type: {
    required: "Please enter card type ",
  },
  cust_name: {
    required: "Please enter customer name ",
    regex: "Only Alphabets and spaces are allowed ",
  },
  cust_mobile: {
    required: "Please enter mobile number ",
    numeric: "Mobile number can only have numbers. ",
    min: "Mobile Number has to be minimum 6 digits.",
    max: "Mobile Number has to be maximum 15 digits.",
  },

  //Vouchers
  voucher_code: {
    required: "Voucher code cannot be empty ",
  },
  voucher_title: {
    required: "Please enter voucher name ",
  },
  voucher_receipt_name: {
    required: "Please enter voucher receipt name ",
  },
  voucher_datetime: {
    required: "Please enter voucher date and time ",
  },
  voucher_enddatetime: {
    required: "Please enter offer end date. ",
  },
  termsandco: {
    required: "Please enter voucher terms and conditions ",
  },
  voucher_amt: {
    required: "Please enter voucher value.",
    numeric: "Only numeric value allowed",
  },
  voucher_min_amt: {
    required: "Please enter minimum amount ",
    numeric: "Only numeric value allowed",
  },
  voucher_max_amt: {
    required: "Please enter maximum amount ",
    numeric: "Only numeric value allowed",
  },
  buy_ticket: {
    required: "Please enter number of buy tickets.",
    numeric: "Only numbers are allowed.",
  },
  get_ticket: {
    required: "Please enter number of get tickets.",
    numeric: "Only numbers are allowed.",
  },

  //  DOCUMENT VERIFICATION DETAILS
  vd_document_name: {
    required: "Document name cannot be empty ",
  },

  /* Setup Organization Settings
   */
  concession_level: {
    required: "Please enter concession level",
    regex: "Only Alphabets, numbers and spaces are allowed",
  },
  "Operation End Time": {
    required: "Please enter Operation End Time",
    regex: "Please enter time in proper format eg - 12:09",
  },
  "Operation Start Time": {
    required: "Please enter Operation Start Time",
    regex: "Please enter time in proper format eg - 12:09",
  },
  imagesettingname: {
    required: "Please Upload Image",
  },
  latitude: {
    required: "Please enter latitude",
    regex: "Please enter proper Latitude. eg: 00.0000 E",
  },

  longitude: {
    required: "Please enter longitude",
    regex: "Please enter proper Longitude. eg: 00.0000 E",
  },
  lastnamee: {
    required: "Please enter last name",
    alpha: "Last Name should be Alphabetical",
  },
  /* End Setup Organization Settings
   */
  contact_no: {
    required: "Please enter contact no.",
    numeric: "Only Numbers are allowed.",
    min: "Please enter minimum 7 numbers.",
    max: "Please enter maximum 12 numbers.",
  },
  number_of_cinemas: {
    required: "Please enter numbers of cinemas",
    numeric: "Only Numbers are allowed.",
  },

  // Setup
  Enter_Activation_Key: {
    required: "Please enter Activation Key.",
    alpha_num: "Only Numbers and Spaces are allowed.",
    min: "Please enter minimum 24 characters.",
    max: "Please enter maximum 24 characters.",
  },

  OrganizationName: {
    required: "Please enter Organization Name",
    alpha_spaces: "Only Alphabets and Space are allowed",
  },
  EmailAddress: {
    email: "Please enter email address properly",
    required: "Please enter Email Address",
  },

  "Activation Key": {
    required: "Please enter Activation Key.",
    alpha_num: "Only Numbers and Spaces are allowed.",
    min: "Please enter minimum 24 characters.",
    max: "Please enter maximum 24 characters.",
  },

  //UserComponent addUser and editUser same for both.
  firstname: {
    required: "Please enter First Name.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
  },
  middlename: {
    required: "Please enter Middle Name.",
    regex: "Only Alphabets, Spaces and - are allowed.",
  },
  lastname: {
    required: "Please enter Last Name.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
  },
  selectgender: {
    required: "Please select Gender.",
  },
  dob: {
    required: "Please select Date of Birth.",
  },
  doj: {
    required: "Please select Date of Joining.",
  },
  address: {
    required: "Please enter Address.",
    alpha_dash: "Alphabets and Dash are allowed.",
    alpha_num: "Alphabets and Numbers are allowed.",
    alpha_spaces: "Alphabets and Numbers are allowed.",
  },
  selectcountry: {
    required: "Please select Country.",
  },
  selectstate: {
    required: "Please select State.",
  },
  selectcity: {
    required: "Please select City.",
  },
  zipcode: {
    required: "Please enter zipcode.",
    numeric: "Only Numbers are allowed.",
  },
  a_email_id: {
    required: "Please enter email address.",
    email: "Please enter correct email address",
  },
  phoneno: {
    // "required": "Please enter Phone Number.",
    numeric: "Only Numbers are allowed.",
    min: "Phone Number has to be minimum 7.",
  },
  mobileno: {
    required: "Please enter Mobile Number.",
    numeric: "Only Numbers are allowed.",
    min: "Mobile Number has to be minimum 8.",
    max: "Mobile Number has to be maximum 14.",
  },
  countrycode: {
    required: "Please Select Country Code.",
  },
  username: {
    required: "Please enter Username.",
    regex: "Only Alphabets,Numbers,'_','-','@' are allowed.",
  },
  password: {
    required: "Please enter Password.",
    regex:
      "Password must contain minimum 6 characters, Contains at least one Lowercase letter, one Uppercase letter, and one Number.",
  },
  selectrole: {
    required: "Please select Role.",
  },
  selectdesignation: {
    required: "Please select Designation.",
  },
  selectcinema: {
    required: "Please select Cinema.",
  },
  employeeid: {
    required: "Please enter Employee ID.",
    alpha_num: "Only Alphabets and Numbers are allowed.",
  },
  selectdepartment: {
    required: "Please select Department.",
  },

  //RolesComponent addRoles and editRoles.
  role_name: {
    required: "Please enter Role name.",
    regex: "Only Alphabets and Numbers are allowed.",
    min: "Please enter minimum 3 characters.",
    max: "Please enter maximum 20 characters.",
  },

  //DesignationComponent addDesignation and editDesignation.
  designation: {
    required: "Please enter Designation.",
    regex: "Only Alphabets, Spaces, & and - are allowed.",
    min: "Please enter minimum 3 characters.",
    max: "Please enter maximum 15 characters.",
  },

  //DepartmentComponent addDepartment and editDepartment.
  dept_name: {
    required: "Please enter Department.",
    regex: "Only Alphabets, Spaces, & and - are allowed.",
  },
  // "dept_code": {
  //     "required": "Please enter Department Code.",
  //     "alpha_num": "Only Alphabets and Numbers are allowed.",
  //     "min": "Please enter minimum 2 characters.",
  //     "max": "Please enter maximum 6 characters."
  // },

  //GenderComponent addGender and editGender.
  gender: {
    required: "Please enter Gender.",
    alpha: "Only Alphabets are allowed.",
  },

  //MaritalStatusesComponent addMaritalStatus and editMaritalStatus.
  ms_name: {
    required: "Please enter Marital Status.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
    min: "Please enter minimum 3 characters.",
    max: "Please enter maximum 15 characters.",
  },

  //StatesComponent addState and editState.
  state_name: {
    required: "Please enter State Name.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
    min: "Please enter minimum 3 characters.",
    max: "Please enter maximum 15 characters.",
  },
  state_code: {
    required: "Please enter State Code.",
    alpha_num: "Only Alphabets and Numbers are allowed.",
    min: "Please enter minimum 2 characters.",
    max: "Please enter maximum 10 characters.",
  },
  country_id: {
    required: "Please Select Country.",
  },

  //CountriesComponent addCountry and editCountry.
  country_name: {
    required: "Please enter Country Name.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
    min: "Please enter minimum 3 characters.",
    max: "Please enter maximum 30 characters.",
  },
  country_code: {
    required: "Please enter Country Code.",
    min: "Please enter minimum 2 characters.",
    max: "Please enter maximum 10 characters.",
  },
  iso_code: {
    required: "Please enter ISO Code.",
    min: "Please enter minimum 2 characters.",
    max: "Please enter maximum 10 characters.",
  },
  iso_2: {
    required: "Please enter ISO 2 Code.",
    min: "Please enter minimum 2 characters.",
    max: "Please enter maximum 10 characters.",
  },
  iso_3: {
    required: "Please enter ISO 3 Code.",
    min: "Please enter minimum 2 characters.",
    max: "Please enter maximum 10 characters.",
  },

  //CityComponent addCity and editCity.
  city_name: {
    required: "Please enter City Name.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
    min: "Please enter minimum 3 characters.",
    max: "Please enter maximum 15 characters.",
  },
  city_latitude: {
    required: "Please enter City Latitude.",
    decimal: "Only Numbers are allowed. e.g. 24312 or 24312.12",
  },
  city_longitude: {
    required: "Please enter City Longitude.",
    decimal: "Only Numbers are allowed. e.g. 24312 or 24312.12",
  },
  country_id: {
    required: "Please Select Country.",
  },
  state_id: {
    required: "Please Select State.",
  },

  //GenreComponent addGenre and editGenre.
  g_name: {
    required: "Please enter Genre.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
  },

  //MoviesCategoriesComponent addMovieCategory and editMovieCategory.
  mc_name: {
    required: "Please enter Movie Category.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
  },

  //RatingsComponent addRating and editRating.
  rating: {
    required: "Please enter Ratings.",
    regex: "Only Alphabets, Special Character and Numbers are allowed.",
    min: "Please enter minimum 1 character.",
    max: "Please enter maximum 20 characters.",
  },

  //UnitofMeasurementComponent addUnitOfMeasurement and editUnitOfMeasurement.
  uom: {
    required: "Please enter Unit Of Measurement.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
  },
  shortform: {
    required: "Please enter Short Form.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
  },
  formula: {
    required: "Please enter Formula.",
    numeric: "Only Numbers are allowed.",
  },
  desc: {
    required: "Please enter Description.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
  },

  //WeekdayComponent editWeekday.
  wd_day: {
    required: "Please enter Weekday.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
  },

  //SignageTypesComponent addSignageType editSignageType.
  st_name: {
    required: "Please enter Signage Type.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
  },

  //SignageURLComponents
  su_name: {
    required: "Please enter Signage URL name.",
  },

  //SeatReservationTypeComponent addSeatReservationType and editSeatReservationType.
  srt_name: {
    required: "Please enter Seat Reservation Type.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
    min: "Please enter minimum 3 characters.",
    max: "Please enter maximum 15 characters.",
  },

  //RefundReasonComponent addRefundReason and editRefundReason.
  rr_reason: {
    required: "Please enter Refund Reason.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
    min: "Please enter minimum 3 characters.",
    max: "Please enter maximum 100 characters.",
  },

  //PaymentModesComponent addPaymentMode and editPaymentMode.
  pm_payment_mode: {
    required: "Please enter Payment Mode.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
    min: "Please enter minimum 3 characters.",
    max: "Please enter maximum 15 characters.",
  },

  //MovieFormatComponent addMovieFormat and editMovieFormat.
  mf_name: {
    required: "Please enter Movie Format.",
    regex: "Please enter proper movie format. eg. 4D or 4D max",
    min: "Please enter minimum 2 Characters.",
  },

  //LanguageComponent addLanguage and editLanguage.
  lang_name: {
    required: "Please enter Language.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
    min: "Please enter minimum 3 characters.",
  },

  //ImageSettingComponent addImageSetting and editImageSetting.
  image_setting_name: {
    required: "Please enter Image Setting Name.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
    min: "Please enter minimum 3 characters.",
  },
  image_setting_height: {
    required: "Please enter Height.",
    numeric: "Only Numbers are allowed.",
  },
  image_setting_width: {
    required: "Please enter Width.",
    numeric: "Only Numbers are allowed.",
  },
  image_setting_ratio: {
    required: "Please enter Ratio.",
    numeric: "Only Numbers are allowed.",
  },
  image_setting_desciption: {
    required: "Please enter image description.",
  },

  //HardwaresComponent addHardware and editHardware.
  h_name: {
    required: "Please enter Hardware Name.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
    min: "Please enter minimum 3 characters.",
  },

  //CurrencyComponent addCurrency and editCurrency.
  curr_name: {
    required: "Please enter Currency.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
    min: "Please enter minimum 3 characters.",
    max: "Please enter maximum 25 characters.",
  },
  currency_id: {
    required: "Please enter Currency value",
  },
  curr_code: {
    required: "Please enter Currency Code.",
    alpha: "Only Alphabets are allowed.",
    min: "Please enter minimum 2 characters.",
    max: "Please enter maximum 4 characters.",
  },
  effective_date: {
    required: "Please enter effective date",
    alpha: "Only Alphabets are allowed.",
    min: "Please enter minimum 2 characters.",
    max: "Please enter maximum 4 characters.",
  },

  //CrewComponent addCrew and editCrew.
  crew_title: {
    required: "Please enter Crew Name.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
    min: "Please enter minimum 3 characters.",
  },

  //ChargeTypeComponent addChargeType and editChargeType.
  ct_name: {
    required: "Please enter Charge Type.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
    min: "Please enter minimum 3 characters.",
  },
  ct_code: {
    required: "Please enter Charge Type Code.",
    alpha_dash: "Only Alphabets, Dashes and Underscores are allowed.",
  },

  //BookingUserCategoriesComponent addBookingUserCategories and editBookingUserCategories.
  buc_category_name: {
    required: "Please enter Booking User Category.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
    min: "Please enter minimum 3 characters.",
  },

  //BookingSourcesComponent addBookingSources and editBookingSources.
  bs_source: {
    required: "Please enter Booking Source.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
    min: "Please enter minimum 3 characters.",
  },

  //BackupSettingComponent addBackupSetting and editBackupSetting.
  selectcinema: {
    required: "Please Select Cinema.",
  },
  fileselector: {
    required: "Please Select Backup Location.",
  },
  daily: {
    required: "Please enter Daily Time.",
    numeric: "Only Numbers are allowed.",
  },
  selectday: {
    required: "Please Select Day.",
  },
  weeklyin: {
    required: "Please enter Weekly Time.",
  },
  fortnight_1: {
    required: "Please Select Start Date.",
  },
  fortnight_2: {
    required: "Please Select End Date.",
  },
  fortnight_3: {
    required: "Please Select Start Time.",
  },
  fortnight_4: {
    required: "Please Select End Time.",
  },
  monthly_1: {
    required: "Please Select Monthly Date.",
  },
  monthly_2: {
    required: "Please Select Monthly Time.",
  },

  //DenominationsComponent addDenomination and editDenomination.
  select_country: {
    required: "Please Select Country.",
  },
  select_currency: {
    required: "Please Select Currency.",
  },
  denomination_val: {
    required: "Please enter Denomination Value.",
    decimal: "Only numbers are allowed. e.g. 10.25 OR 10",
  },

  //FeaturesComponent addFeature and editFeature.
  feature_name: {
    required: "Please enter Feature Name.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
  },
  module_id: {
    required: "Please Select Module.",
  },
  feature_routes: {
    required: "Please enter Routes / Path.",
  },

  //ModulesComponent addModule and editModule.
  module_name: {
    required: "Please enter Module Name.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
  },

  //OrganizationsComponent addOrganization and editOrganization.
  org_name: {
    required: "Please enter Organization Name.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
  },
  org_logo_url: {
    required: "Please enter Organization Logo URL.",
  },
  org_address: {
    required: "Please enter Organization Address.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
  },
  org_no_of_cinemas: {
    required: "Please enter No of Cinema.",
    numeric: "Only Numbers are allowed.",
  },
  org_pincode: {
    required: "Please enter Zipcode.",
    numeric: "Only Numbers are allowed.",
  },
  country_id: {
    required: "Please Select Country.",
  },
  state_id: {
    required: "Please Select State.",
  },
  city_id: {
    required: "Please Select City.",
  },
  org_contact_no: {
    required: "Please enter Contact Number.",
    numeric: "Only Numbers are allowed.",
  },
  org_setup_date: {
    required: "Please Select Setup Date.",
  },
  org_launch_date: {
    required: "Please Select Launch Date.",
  },
  org_kiosk_screen_image_url: {
    required: "Please Select Kiosk Screen Image.",
  },
  ticket_image_url: {
    required: "Please Select Ticket Image.",
  },
  org_color: {
    required: "Please Select Organisation color.",
  },
  org_hover_color: {
    required: "Please Select Organisation hover color.",
  },
  org_font_color: {
    required: "Please Select Organisation Font color.",
  },
  org_website_url: {
    required: "Please Enter Organization website URL.",
  },
  org_mycinema_logo: {
    required: "Please select Organization Mycinema Logo.",
  },

  //ProductionCompanyComponent addProductionCompany and editProductionCompany.
  production_name: {
    required: "Please enter Production Company Name.",
    regex: "Only Alphabets, Numbers, Spaces and Dashes are allowed.",
    min: "Please enter minimum 3 characters.",
    max: "Please enter maximum 50 characters.",
  },

  //StatuesComponent addStatues and editStatues.
  s_status_code: {
    required: "Please enter Statues Code.",
    "alpha_dash ":
      "Only Alphabets, Dashes, Underscores and Numbers are allowed.",
  },
  s_status_display: {
    required: "Please enter Statues Display Name.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
  },

  //DistributorShateTypeComponent addDistributorShareType and editDistributorShareType
  sharelabel: {
    required: "Please enter Share Label.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
  },

  select_week: {
    required: "Please Select Week.",
  },
  select_contract: {
    required: "Please Select Contract.",
  },

  //DistributorShareComponent distributor
  selectmovie_1: {
    required: "Please Select Movie.",
  },
  selectmovie_2: {
    required: "Please Select Movie.",
  },
  selectcinema_1: {
    required: "Please Select Cinema.",
  },
  selectfromdate: {
    required: "Please Select From Date.",
  },
  selectenddate: {
    required: "Please Select End Date.",
  },

  //DistributorContractComponent addDistributorContract
  selectcine_1: {
    required: "Please Select Cinema.",
  },
  md_id: {
    required: "Please Select Movie.",
  },
  selectdistri_1: {
    required: "Please Select Distributor.",
  },
  selectfromdate_1: {
    required: "Please Select From Date.",
  },
  selectenddate_1: {
    required: "Please Select End Date.",
  },
  selectdistrisharetype: {
    required: "Please Select Distributor Share Type.",
  },
  sharevalue_1: {
    required: "Please Select Share Value.",
    numeric: "Only Numbers are allowed.",
  },

  //ShiftsComponent addShift and editShift
  shift_name: {
    required: "Please enter Shift Name.",
    regex: "Only Alphabets and Spaces are allowed.",
    min: "The shift name field must be atleast 3 characters",
  },
  shift_working_hrs: {
    required: "Please enter Shift Working Hours.",
    regex: "Only Alphabets, Numbers, Spaces and Colons are allowed.",
  },
  shift_start_time: {
    required: "Please enter Shift Start Time.",
    // "regex": "Please enter Proper Start Time. e.g. 10:00"
  },
  shift_end_time: {
    required: "Please enter Shift End Time.",
    regex: "Please enter Proper End Time. e.g. 12:00",
  },

  //UserShiftsComponent addUserShift and editUserShift
  "selectcinema-1": {
    required: "Please Select Cinema.",
  },
  selectuser: {
    required: "Please Select User.",
  },
  selectshift: {
    required: "Please Select Shift.",
  },
  "shiftstart-1": {
    required: "Please Select Shift Start Date.",
  },
  "shiftend-1": {
    required: "Please Select Shift End Date.",
  },

  //MoviesComponent addMovies and editMovies
  movietitle: {
    required: "Please enter Movie Title.",
    // "alpha_spaces": "Only Alphabets and Spaces are allowed."
  },
  movietrailer: {
    required: "Please enter movie trailer link",
  },
  moviecopyright: {
    required: "Please enter copyright information",
  },
  moviereleasedate: {
    required: "Please select movie release date",
  },
  originalreleasedate: {
    required: "Please select movie's original release date",
  },
  "selectcountry-1": {
    required: "Please Select Country.",
  },
  selectproduction: {
    required: "Please Select Production Company.",
  },
  selectgenre: {
    required: "Please Select Genre.",
  },
  selectlanguage: {
    required: "Please Select Language.",
  },
  selectformat: {
    required: "Please Select Format.",
  },
  trailers: {
    required: "Please enter Movie Trailer.",
    // "alpha_spaces": "Only Alphabets and Spaces are allowed."
  },
  uploadimage: {
    required: "Please Upload Thumbnail Image.",
  },
  preferred_language_id: {
    required: "Please select preferred language",
  },
  "selectdistributor-1": {
    required: "Please Select Distributor.",
  },
  selectcoun: {
    required: "Please Select Country.",
  },
  selectstat: {
    required: "Please Select State.",
  },
  selectcty: {
    required: "Please Select City.",
  },
  fdate: {
    required: "Please Select From Date.",
  },
  todate: {
    required: "Please Select To Date.",
  },
  movierating: {
    required: "Please Select Movie Rating.",
  },
  releasedate: {
    required: "Please Select Release Date.",
  },
  runtime: {
    required: "Please enter Run Time.",
    numeric: "Only numbers are allowed.",
    min: "Please enter minimum 2 characters.",
    max: "Please enter maximum 3 characters.",
  },
  contenttitle: {
    required: "Please enter Movie Title.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
  },
  movie_description: {
    required: "Please enter Movie Description.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
  },
  short_movie_description: {
    required: "Please enter Short Movie Description.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
  },
  long_movie_description: {
    required: "Please enter Long Movie Description.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
  },
  crew: {
    required: "Please Select Crew.",
  },
  nameofperson: {
    required: "Please enter Name of The Person.",
  },
  order: {
    required: "Please enter Order.",
    numeric: "Only Numbers are allowed.",
  },
  image: {
    required: "Please Select Image.",
  },

  //CinemasComponent addCinemas and editCinemas
  cine_name: {
    required: "Please enter Cinema Name.",
    min: "Please enter minimum 3 characters.",
    max: "Please enter maximum 50 characters.",
  },
  alternate_cinema_name_language: {
    min: "Please enter minimum 3 characters.",
    max: "Please enter maximum 50 characters.",
  },
  cine_code: {
    required: "Please enter Cinema Code.",
    alpha_num: "Only Alphabets and Numbers are allowed.",
  },
  org: {
    required: "Please Select Organization.",
  },
  cine_location: {
    required: "Please enter Location.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
    min: "Please enter minimum 3 characters.",
    max: "Please enter maximum 50 characters.",
  },
  cine_address: {
    required: "Please enter Address.",
    min: "Please enter minimum 3 characters.",
    max: "Please enter maximum 255 characters.",
  },
  cine_pincode: {
    required: "Please enter Zipcode.",
    numeric: "Only Numbers are allowed.",
    alpha_num: "Only Numbers and Alphabets are allowed.",
    min: "Please enter minimum 6 characters.",
    max: "Please enter maximum 6 characters.",
  },
  curr: {
    required: "Please Select Currency.",
  },
  coun: {
    required: "Please Select Country.",
  },
  state: {
    required: "Please Select State.",
  },
  city: {
    required: "Please Select City.",
  },
  cine_phone: {
    required: "Please enter Phone Number.",
    numeric: "Only Numbers are allowed.",
    min: "Please enter minimum 6 numbers.",
    max: "Please enter maximum 12 numbers.",
  },
  cine_email: {
    required: "Please enter email address.",
    email: "Please enter correct email address.",
  },
  cine_screens: {
    required: "Please enter Screen Number.",
    numeric: "Only Numbers are allowed.",
    max: "Please enter maximum 2 characters.",
  },
  cine_latitude: {
    required: "Please enter Latitude.",
    decimal: "Only Numbers are allowed. e.g. 24312 or 24312.12",
  },
  cine_longitude: {
    required: "Please enter Longitude.",
    decimal: "Only Numbers are allowed. e.g. 24312 or 24312.12",
  },
  cine_booking_cut_off_time: {
    required: "Please enter Cut Off Time.",
    max: "Please enter maximum 10 characters.",
  },
  cine_license_number: {
    required: "Please enter License Number.",
    alpha_num: "Only Alphabets and Numbers are allowed.",
    min: "Please enter minimum 5 characters.",
    max: "Please enter maximum 30 characters.",
  },
  cine_registration_number: {
    required: "Please enter Registration Number.",
    alpha_num: "Only Alphabets and Numbers are allowed.",
    min: "Please enter minimum 5 characters.",
    max: "Please enter maximum 30 characters.",
  },
  cine_operations_start_time: {
    required: "Please enter Operation Start Time.",
    max: "Please enter maximum 10 characters.",
  },
  cine_operations_end_time: {
    required: "Please enter Operation End Time.",
    max: "Please enter maximum 10 characters.",
  },
  cine_concession_level: {
    required: "Please enter Cinema Concession Level.",
    min: "Please enter maximum 3 characters.",
    max: "Please enter maximum 50 characters.",
  },
  cine_image_url: {
    required: "Please upload image.",
  },

  //CinemasScreensComponent addCinemasScreen and editCinemasScreen
  screen_name: {
    required: "Please enter Screen Name.",
    regex: "Only Alphabets, Numbers and Spaces are allowed.",
    min: "Please enter minimum 3 characters.",
    max: "Please enter maximum 15 characters.",
  },
  screen_no_of_seats: {
    required: "Please enter No. of Seats.",
    numeric: "Only Numbers are allowed.",
  },
  screen_no_of_cols: {
    required: "Please enter No. of Columns.",
    numeric: "Only Numbers are allowed.",
  },
  screen_no_of_rows: {
    required: "Please enter No. of Rows.",
    numeric: "Only Numbers are allowed.",
  },
  screen_size_format: {
    required: "Please enter Screen Size Format",
    regex: "Only Alphabets, Numbers and Spaces are allowed.",
    min: "Please enter minimum 2 characters.",
    max: "Please enter maximum 15 characters.",
  },
  min_seats: {
    required: "Please enter minimum no. of seats",
    numeric: "Only Numbers are allowed.",
  },
  unique_screen_id: {
    required: "Please enter unique screen ID",
  },

  //SeatTypeComponent addSeatType and editSeatType
  seattype: {
    required: "Please enter Seat Type.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
  },
  seatno: {
    required: "Please enter No. of Seats.",
    numeric: "Only Numbers are allowed.",
  },

  //ScheduleComponent addSchedule
  showstartdate: {
    required: "Please Select Show Start Date.",
  },
  delete_reason: {
    required: "Please Enter Reason to Delete Show.",
  },
  comment_name: {
    required: "Please Select Comment.",
  },
  showenddate: {
    required: "Please Select Show End Date.",
  },
  showtime: {
    required: "Please Select Show Time.",
  },

  //RateCardComponent addRateCard and editRateCard
  ratename: {
    required: "Please enter Rate Card Name.",
    regex: "Only Alphabets and Numbers are allowed.",
  },
  rateamount: {
    required: "Please enter Rate Amount.",
    decimal: "Only Numbers are allowed. e.g. 100 or 100.25",
  },

  //ChargeSettingComponent addChargeSetting and editChargeSetting
  chargesetting: {
    required: "Please enter Charge Setting Name.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
  },
  chargevalue: {
    required: "Please enter Charge Value.",
    decimal: "Only Numbers are allowed. eg- 100 or 10.25",
  },
  fd: {
    required: "Please Select From Date.",
  },
  td: {
    required: "Please Select To Date.",
  },

  //CinemaSettingComponent addCinemaSetting and editCinemaSetting
  concessionlevel: {
    required: "Please enter Cinema Setting Name.",
    max: "Please enter maximum 30 characters.",
  },
  operationstime: {
    required: "Please enter Business Start Time.",
    regex: "Only Numbers are allowed. e.g. 23:00 or 23",
  },
  operationetime: {
    required: "Please enter Business End Time.",
    regex: "Only Numbers are allowed. e.g. 23:00 or 23",
  },
  cleaningtime: {
    required: "Please enter Cleaning Time.",
    numeric: "Only Numbers are allowed.",
  },
  settingadstime: {
    required: "Please enter Advertisement Time.",
    numeric: "Only Numbers are allowed.",
  },
  intervaltime: {
    required: "Please enter Intermission Time.",
    numeric: "Only Numbers are allowed.",
  },
  mycinema_creation_interval_time: {
    numeric: "Only Numbers are allowed.",
  },
  releasetime: {
    required: "Please enter Release Time.",
    numeric: "Only Numbers are allowed.",
  },
  cutofftime: {
    required: "Please enter Cut Off Time.",
    numeric: "Only Numbers are allowed.",
  },
  kioskcutofftime: {
    required: "Please enter Kiosk Cut Off Time.",
    numeric: "Only Numbers are allowed.",
  },
  websitecutofftime: {
    required: "Please enter Website Cut Off Time.",
    numeric: "Only Numbers are allowed.",
  },
  ipaddress: {
    required: "Please enter IP Address Range.",
    regex: "Only Decimal numbers, Dots and Asterisk are allowed.",
  },

  //FloatAmountComponent addFloatAmount and editFloatAmount
  floatamount: {
    required: "Please enter Charge Value.",
    decimal: "Only Numbers or Decimal are allowed.",
  },

  //AggregatorsComponent addAggregator and editAggregator
  aggregator_name: {
    required: "Please enter Aggregator Name.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
    min: "Please enter minimum 3 characters.",
    max: "Please enter maximum 15 characters.",
  },
  contract_start_date: {
    required: "Please Select Contract Start Date.",
  },
  contract_end_date: {
    required: "Please Select Contract End Date.",
  },
  aggregator_api_id: {
    required: "Please enter API ID.",
    alpha_num: "Only Alphabets and Numbers are allowed.",
    min: "Please enter minimum 3 characters.",
    max: "Please enter maximum 50 characters.",
  },
  aggregator_authentication_code: {
    required: "Please enter Authentication Code.",
    numeric: "Only Numbers are allowed.",
  },
  aggregator_username: {
    required: "Please enter Username.",
    alpha_num: "No-spaces, Only Alphabets and Numbers are allowed.",
  },
  aggregator_password: {
    required: "Please enter Password.",
    alpha_num: "Only Alphabets and Numbers are allowed.",
  },

  //HardwareSettingsComponent addHardwareSetting and editHardwareSetting
  uname: {
    required: "Please enter Username.",
    // "alpha_num": "Only Alphabets and Numbers are allowed."
  },
  pwd: {
    required: "Please enter Password.",
    regex:
      "Password must contain minimum 8 and maximum 16 characters, Contains at least one Lowercase letter, one Uppercase letter and one Special Character.",
  },
  ucode: {
    required: "Please enter Hardware Unique Code.",
    // "alpha_num": "Only Alphabets and Numbers are allowed."
  },
  hardwarename: {
    required: "Please enter hardware name.",
    regex: "Only Alphabets, Numbers and Spaces are allowed.",
  },
  hardwareremark: {
    required: "Please enter hardware Notes / Remarks.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
  },
  hardwareport: {
    required: "Please enter hardware connection port.",
    numeric: "Only Numbers are allowed.",
  },
  hardwareinstall: {
    required: "Please enter hardware 'Install by'.",
    alpha_spaces: "Alphabets and Spaces are allowed.",
  },

  //RawMaterialComponent addRawMaterial and editRawMaterial
  rawmaterial: {
    required: "Please enter Raw Material Name.",
  },
  rawmaterialcategory: {
    required: "Please enter Raw Material Category.",
  },
  quantity: {
    required: "Please enter Quantity Alert.",
    numeric: "Only Numbers are allowed.",
  },
  uomdropdown: {
    required: "Please Select Unit of Measurement.",
  },

  //VendorComponent addVendor and editVendor
  vendorname: {
    required: "Please enter Vendors Name.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
  },
  vendornumber: {
    // "required": "Please enter Vendors TIN Number.",
    alpha_num: "Only Numbers and Alphabets are allowed.",
    min: "Please enter minimum 3 characters.",
    max: "Please enter maximum 11 characters.",
  },
  vendortax: {
    // "required": "Please enter Vendors Tax Number.",
    alpha_num: "Only Alphabets and Numbers are allowed.",
    min: "Please enter minimum 3 characters.",
    max: "Please enter maximum 15 characters.",
  },
  taxtype: {
    required: "Please enter Vendors Tax Type.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
  },
  vendoraddress: {
    required: "Please enter Vendors Address.",
    // "alpha_spaces": "Only Alphabets and Spaces are allowed."
  },
  vendorno: {
    required: "Please enter Contact Number.",
    numeric: "Only Numbers are allowed.",
    min: "Please enter minimum 6 characters.",
    max: "Please enter maximum 10 characters.",
  },
  vendoremail: {
    required: "Please enter email address.",
    email: "Please enter correct email address.",
  },

  //VendorsMappingComponent addVendorsMapping and editVendorsMapping
  mapquantity: {
    required: "Please enter Quantity.",
    numeric: "Only Numbers are allowed.",
  },
  rate: {
    required: "Please enter Rate.",
    decimal: "Only Numbers are allowed. E.g 100.5 or 100",
  },
  tax: {
    required: "Please enter Tax amount.",
    decimal: "Only Numbers are allowed. E.g 100.5 or 100",
  },

  //PurchaseOrderComponent addPurchaseOrder and editPurchaseOrder
  purchasedate: {
    required: "Please Select Purchase Order Date.",
  },
  propertyInOutDate: {
    required: "Please Select Date.",
  },
  totalrate: {
    required: "Please enter Total Amount.",
    decimal: "Only Numbers and Decimal are allowed.",
  },
  totalamount: {
    required: "Please enter Total Amount.",
    decimal: "Only Numbers and Decimal are allowed.",
  },

  //InvoiceComponents
  invociedate: {
    required: "Please Select Invoice Date.",
  },
  rmname: {
    required: "Please enter Item Name.",
  },
  invoicenetamount: {
    required: "Please enter Net Amount.",
    decimal: "Only Numbers and Decimal are allowed.",
  },
  taxamount: {
    required: "Please enter Tax Amount.",
    decimal: "Only Numbers and Decimal are allowed.",
  },
  totalamount: {
    required: "Please enter Total Amount.",
    decimal: "Only Numbers and Decimal are allowed.",
  },
  finaltotalamount: {
    required: "Please enter Total Amount.",
    decimal: "Only Numbers and Decimal are allowed.",
  },

  //FoodCategoriesComponent addFoodCategories and editFoodCategories
  foodname: {
    required: "Please enter Food Category Name.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
  },
  "file-selector": {
    required: "Please Select Active Image File.",
  },
  "file-selector2": {
    required: "Please Select Inactive Image File.",
  },

  //RecipeComponent addRecipe and editRecipe
  recipename: {
    required: "Please enter Recipe Name.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
  },
  recipecode: {
    required: "Please enter Recipe Code.",
    decimal: "Only Numbers and Decimal are allowed.",
  },
  recipedesc: {
    required: "Please enter Recipe Description.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
  },
  recipeexpiry: {
    required: "Please enter Recipe Expiry Days.",
    numeric: "Only Numbers are allowed.",
  },
  qty: {
    required: "Please enter Quantity.",
    decimal: "Only Numbers and Decimal are allowed.",
  },

  //FnBitemComponent addFnBitem and editFnBitem
  itemcode: {
    required: "Please enter Item Code.",
    alpha_num: "Only Numbers and Alphabetic are allowed.",
  },
  itemname: {
    required: "Please enter Item Name.",
  },
  "file-selector3": {
    required: "Please Select Food Image File.",
  },

  //StoreComponent addStore and editStore
  stockdate: {
    required: "Please Select Stock In Date.",
  },

  //RateCardComponent addRateCard and editRateCard
  cardname: {
    required: "Please enter Rate Card Name.",
    regex: "Only Alphabets and Numbers are allowed.",
  },
  cardamount: {
    required: "Please Select Amount.",
    regex: "Only Numbers are allowed. e.g 100.00 or 100",
  },

  //FnBPricingComponent addFnBPricing and editFnBPricing
  netamount: {
    required: "Please enter Net Amount.",
    regex: "Only Numbers are allowed. e.g. 100.25",
  },
  tamount: {
    required: "Please enter Total Amount.",
    regex: "Only Numbers are allowed. e.g. 100.25",
  },
  fdate1: {
    required: "Please Select From Date.",
  },
  tdate1: {
    required: "Please Select To Date.",
  },

  //FnBWastageComponent addFnBWastage and editFnBWastage
  reason: {
    required: "Please enter Reasons.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
  },
  fineamount: {
    required: "Please enter Fine Amount.",
    numeric: "Only Numbers are allowed.",
  },
  fromd: {
    required: "Please Select From Date.",
  },

  //ItemCostPriceComponent addItemCostPrice and editItemCostPrice
  costprice: {
    required: "Please enter Cost Price.",
    decimal: "Only numbers ar allowed. e.g. 100 or 100.25",
  },

  //OTP (Forgot Password)
  otpnumber: {
    required: "Please enter OTP.",
  },

  //Password & Confirm Password
  forgotpassword: {
    required: "Please enter Password.",
    regex:
      "Password must contain minimum 6 characters, Contains at least one Lowercase letter, one Uppercase letter and one Number.",
  },
  forgotconfirm: {
    required: "Please enter Confirm Password.",
    confirmed: "Confirm Password Doesn't matched.",
  },

  //DistributorsComponent
  d_company_name: {
    required: "Please enter distributor name.",
    min: "Please enter minimum 3 characters.",
  },
  d_sister_company: {
    required: "Please enter Sister Company name.",
  },
  d_contact_no: {
    required: "Please enter contact number.",
    numeric: "Only Numbers are allowed.",
    min: "Please enter minimum 6 numbers.",
    max: "Please enter maximum 15 numbers.",
  },
  d_email_id: {
    required: "Please enter email address.",
    email: "Please enter correct email address.",
  },
  d_tin_number: {
    required: "Please enter TIN number.",
    alpha_num: "Only Alphabets and Numbers are allowed.",
  },
  d_tax_number: {
    required: "Please enter tax number.",
    // alpha_num: "Only alphabets and numbers are allowed."
  },
  d_tax_type: {
    required: "Please enter Tax Type.",
    alpha_num: "Only Alphabets and Numbers are allowed.",
  },
  d_address: {
    required: "Please enter Address.",
  },

  //Renunciation
  renunciationremark: {
    required: "Please enter Reason of Leaving.",
  },
  dateleaving: {
    required: "Please Select Date of Leaving.",
  },

  //Concession
  concession_name: {
    required: "Please enter Concession Name.",
  },
  concession_pos: {
    required: "Please enter No. of POS.",
    numeric: "Only Numbers are allowed.",
  },
  concession_kiosk: {
    required: "Please enter No. of Kiosk",
    numeric: "Only Numbers are allowed.",
  },
  concession_signage: {
    required: "Please enter No. of Signage.",
    numeric: "Only Numbers are allowed.",
  },
  concession_counter: {
    required: "Please enter No. of F&B Counter.",
    numeric: "Only Numbers are allowed.",
  },

  //Change Password
  currentpass: {
    required: "Please Enter Current Password.",
  },

  //Reserve Seats
  showdate: {
    required: "Please Selecet Show Date.",
  },

  //Setup Organization
  telephone_no: {
    required: "Please enter Telephone number.",
    numeric: "Only Numbers are allowed.",
    max: "Maximum 16 numbers are allowed.",
  },

  pincode: {
    required: "Please enter Zipcode.",
    alpha_num: "Only Alphabets and Numbers are allowed.",
    max: "Maximum 10 Alphabets and Numbers are allowed.",
  },

  "registration number": {
    required: "Please enter Registration Number.",
    regex: "Only Alphabets, Numbers and Spaces are allowed.",
  },

  "Registered Office": {
    required: "Please enter Registered Office.",
  },

  "image setting name": {
    required: "Please enter Image Setting Name.",
  },

  height: {
    required: "Please enter Height.",
    numeric: "Only Numbers are allowed.",
  },

  width: {
    required: "Please enter Width.",
    numeric: "Only Numbers are allowed.",
  },

  "Organization Name": {
    required: "Please enter Organization Name.",
  },

  "Cinema Name": {
    required: "Please enter Cinema Name.",
    regex: "Only Alphabets, Numbers and Spaces are allowed.",
  },
  "license number": {
    required: "Please enter Registration Number.",
    alpha_num: "Only Alphabets and Numbers are allowed.",
    min: "Minimum 5 Alphabets and Numbers are allowed.",
    max: "Maximum 30 Alphabets and Numbers are allowed.",
  },
  "Cleaning Time": {
    required: "Please enter Cleaning Time.",
    numeric: "Only Numbers are allowed.",
  },
  "Advertisement Time": {
    required: "Please enter Advertisement Time.",
    numeric: "Only Numbers are allowed.",
  },
  "Cutoff Time": {
    required: "Please enter Cutoff Time.",
    numeric: "Only Numbers are allowed.",
  },
  "Seat Release": {
    required: "Please enter Seat Release.",
    numeric: "Only Numbers are allowed.",
  },
  "Interval Time": {
    required: "Please enter Interval Time.",
    numeric: "Only Numbers are allowed.",
  },
  latitude_setup: {
    decimal: "Only Numbers are allowed. e.g 45342 or 45342.12",
  },
  longitude_setup: {
    decimal: "Only Numbers are allowed. e.g 45342 or 45342.12",
  },
  //Templates
  template_name: {
    required: "Please enter Template Name.",
  },
  special_text: {
    required: "Please enter Special Instructions.",
  },

  //Release Seat
  ticketno: {
    required: "Please enter Ticket No.",
  },

  //GlobalLoyaltySettings Componets
  loyaltysettingname: {
    required: "Please enter Global Loyalty Setting Name",
  },
  initialload: {
    required: "Please enter Inital Amount",
    decimal:
      "The initial amount field must be numeric and may contain decimal points",
  },
  expiryvalue: {
    required: "Please enter Expiry value",
    decimal:
      "The  expiry value field must be numeric and may contain decimal points",
  },
  loyaltylevelname: {
    required: "Please enter Loyalty Level Name",
  },
  pointrquired: {
    required: "Please enter Points required",
    decimal:
      "The  points required field must be numeric and may contain decimal points",
  },
  bonuspoint: {
    required: "Please enter Bonus Points",
  },

  //CinemaLoyaltySettings Components
  cinemaloyaltyname: {
    required: "Please enter Loyalty Setting Name",
  },
  selectcinema: {
    required: "Please select Cinema",
  },
  minimumreedempoints: {
    required: "Please enter Minimum points for redemption",
    decimal:
      "The minimum reedem points field must be numeric and may contain decimal points",
  },
  maximumreedempoints: {
    required: "Please enter Maximum points for redemption",
    decimal:
      "The maximum reedem points field must be numeric and may contain decimal points",
  },
  minimumpointearning: {
    required: "Please enter Minimum points earning",
    decimal:
      "The minimum point earning field must be numeric and may contain decimal points",
  },
  maximumpointearning: {
    required: "Please enter Maximum points earning",
    decimal:
      "The maximum point earning field must be numeric and may contain decimal points",
  },
  eligibilitytoenroll: {
    required: "Please enter Eligiblity to enroll",
  },
  earnboxofficeratio: {
    required: "Please enter Box Office Ratio for Earn Points",
    decimal:
      "The earn box office ratio field must be numeric and may contain decimal points",
  },
  earnfnbratio: {
    required: "Please enter Food & Beverages Ratio for Earn Points",
    decimal:
      "The earn FnB ratio field must be numeric and may contain decimal points",
  },
  burnboxofficeratio: {
    required: "Please enter Box Office Ratio for Burn Points",
    decimal:
      "The burn box office ratio field must be numeric and may contain decimal points",
  },
  burnfnbratio: {
    required: "Please enter Food & Beverages Ratio for Burn Points",
    decimal:
      "The burn FnB ratio field must be numeric and may contain decimal points",
  },

  //EmailTemplate Components
  emailtemplatename: {
    required: "Please enter Email Template Name",
  },
  emailtitle: {
    required: "Please enter Email Name",
  },
  emaildesc: {
    required: "Please enter Email Content.",
  },

  //SendEmail in Listemailtemplate
  toemail: {
    required: "Please provide email",
    email: "Please enter correct email address",
  },

  //SMSTemplate Components
  smstemplatename: {
    required: "Please enter SMS Template Name",
  },
  smstext: {
    required: "Please enter Text",
  },

  //Feedback Form Components
  form_name: {
    required: "Please enter form name.",
    alpha_spaces: "Only Alphabets and Spaces are allowed.",
  },
  form_description: {
    required: "Please enter form description.",
  },
  form_field: {
    required: "Please enter form field.",
    // "alpha_spaces": "Only Alphabets and Spaces are allowed."
  },
  min_length: {
    required: "Please enter minimum length.",
    numeric: "Only Numbers are allowed.",
  },
  max_length: {
    required: "Please enter maximum length.",
    numeric: "Only Numbers are allowed.",
  },

  //Support Ticket Category
  category_name: {
    required: "Please enter Category Name.",
  },

  //Support Ticket
  subject: {
    required: "Please enter Subject.",
  },
  description: {
    required: "Please enter Description.",
  },

  //checklist category
  category_description: {
    required: "Please enter Description.",
  },

  //checklist
  checklist_name: {
    required: "Please enter Checklist Name.",
  },
  selected_category: {
    required: "Please select Checklist Category.",
  },
  selected_cinema: {
    required: "Please select Cinema",
  },

  //Add & Edit Banners
  banner_name: {
    required: "Please enter Banner Name.",
  },
  banner_header: {
    required: "Please enter Banner Header.",
  },
  banner_subheader: {
    required: "Please enter Banner Sub-Header.",
  },
  banner_description: {
    required: "Please enter Banner Description.",
  },

  //PosBooking
  card_number: {
    numeric: "Please enter only numbers",
    min: "Please enter minimum 12 digits",
    max: "Please enter maximum 12 digits",
  },

  //Cash Card
  initial_amount: {
    required: "Please enter the amount",
    numeric: "Please enter only numbers",
  },
  cash_card_number: {
    required: "Please enter the card number",
    max: "Please enter maximum 16 characters.",
  },

  remaining_balance: {
    required: "Please enter the remaining balance",
    numeric: "Please enter only numbers",
  },

  //FnBDynamicPricing
  pricing_name: {
    required: "Please enter pricing name.",
    regex: "Only alphabets, spaces and numbers are allowed.",
  },
  new_item_price: {
    required: "Please enter new item net price.",
    decimal: "Only numbers are allowed.e.g 100.50 OR 100.",
  },
  //Add-ons
  addon_item_name: {
    required: "Please enter add-on item name.",
    alpha_spaces: "Only alphabets and spaces are allowed.",
  },
  max_qty: {
    required: "Please enter max quantity.",
    decimal: "Only numbers are allowed e.g 100.50 OR 100.",
  },
  addon_item_price: {
    required: "Please enter item price.",
    decimal: "Only numbers are allowed e.g 100.50 OR 100.",
  },
  //Cinema types
  cinema_type_name: {
    required: "Please enter cinema type name.",
    alpha_spaces: "Only alphabets and spaces are allowed.",
  },
  //Tier types
  tier_type_name: {
    required: "Please enter tier type name.",
    regex: "Only alphabets, numbers and spaces are allowed.",
  },
  //Weekwise Contract
  weekwise_name: {
    required: "Please enter week wise contract name.",
    regex: "Only alphabets, spaces and numbers are allowed.",
  },
  //Sound Format
  sound_format_name: {
    required: "Please enter sound format name.",
  },
  sound_format_order: {
    required: "Please enter sound format Order.",
  },
  //Store Management
  sm_store_name: {
    required: "Please enter store name.",
    regex: "Only alphabets, spaces and numbers are allowed.",
  },
  sm_store_slug: {
    required: "Please enter store slug.",
    regex: "Only alphabets, spaces and numbers are allowed.",
  },

  //Transfer Stock
  transfer_qty: {
    required: "Please enter quantity.",
    numeric: "Only numbers are allowed.",
  },
  adjustment_rate: {
    required: "Please enter rate per item",
    numeric: "Only numbers are allowed.",
  },
  adjustment_tax: {
    required: "Please total Tax",
    numeric: "Only numbers are allowed.",
  },

  //FnB wastage
  wastage_qty: {
    required: "Please enter quantity.",
    numeric: "Only numbers are allowed.",
  },
  fineamount: {
    required: "Please enter total amount.",
    decimal: "Only numbers are allowed. eg. 100 or 100.25",
    max: "Please enter maximum 5 numbers.",
  },
  remark: {
    required: "Please enter remark.",
  },

  //Promotion and Offers
  offer_title: {
    required: "Please enter offer title.",
  },
  share_value: {
    required: "Please enter share value.",
    decimal: "Only numbers are allowed. e.g. 100.50 OR 100",
  },
  buy_value: {
    required: 'Please enter "Buy" value.',
    numeric: "Only numbers are allowed.",
  },
  get_value: {
    required: 'Please enter "Get" value.',
    numeric: "Only numbers are allowed.",
  },
  min_ticket_amount: {
    required: "Please enter minimum ticket amount.",
    decimal: "Only numbers are allowed. e.g. 100.50 OR 100",
  },
  max_ticket: {
    required: "Please enter maximum free ticket per transaction.",
    numeric: "Only numbers are allowed.",
  },
  discount_buy_value: {
    required: 'Please enter "Buy" value.',
    numeric: "Only numbers are allowed.",
  },
  discount_get_value: {
    required: 'Please enter "get discount of" value.',
    numeric: "Only numbers are allowed.",
  },
  max_discount_per_trans: {
    required: "Please enter maximum discount per transaction.",
    numeric: "Only numbers are allowed.",
  },
  buy_fnb_combo: {
    required: 'Please enter "Buy" value for F&B.',
    numeric: "Only numbers are allowed.",
  },
  get_fnb_combo: {
    required: 'Please enter "Get" value for F&B.',
    numeric: "Only numbers are allowed.",
  },
  free_combo_offer_value: {
    required: "Please enter offer value.",
    decimal: "Only numbers are allowed. e.g. 100.50 OR 100",
  },
  buy_bo_combo: {
    required: 'Please enter "Buy" value for Box Office.',
    numeric: "Only numbers are allowed.",
  },
  free_combo_bo_offer_value: {
    required: "Please enter offer value.",
    decimal: "Only numbers are allowed. e.g. 100.50 OR 100",
  },
  customer_min_ticket_amount: {
    required: "Please enter minimum ticket amount.",
    decimal: "Only numbers are allowed. e.g. 100.50 OR 100",
  },
  customer_max_discount_per_trans: {
    required: "Please enter maximum discount per transaction.",
    numeric: "Only numbers are allowed.",
  },
  customer_offer_value: {
    required: "Please enter offer price.",
    decimal: "Only numbers are allowed. e.g. 100.50 OR 100",
  },
  bank_redemption_count: {
    required: "Please enter redemption count.",
    numeric: "Only numbers are allowed.",
  },
  bank_max_redemption_per_user: {
    required: "Please enter max redemption per user.",
    numeric: "Only numbers are allowed.",
  },
  bank_offer_value: {
    required: "Please enter offer price.",
    decimal: "Only numbers are allowed. e.g. 100.50 OR 100",
  },
  promo_code: {
    required: "Please enter promo code.",
    alpha_num: "Only alphabets and numbers are allowed.",
  },
  applicalbe_for: {
    required: "Please enter no. of transaction.",
    numeric: "Only numbers are allowed.",
  },
  promo_min_ticket_amount: {
    required: "Please enter minimum ticket amount.",
    decimal: "Only numbers are allowed. e.g. 100.50 OR 100",
  },
  promo_max_discount_per_user: {
    required: "Please enter maximum discount per transaction.",
    numeric: "Only numbers are allowed.",
  },
  promo_offer_value: {
    required: "Please enter offer price.",
    decimal: "Only numbers are allowed. e.g. 100.50 OR 100",
  },

  //Create New Password PIN
  passwordpin: {
    required: "Please enter new password.",
    numeric: "Only numbers are allowed.",
    min: "Please enter minimum 4 numbers.",
    max: "Please enter maximum 8 numbers.",
  },
  confirm_password: {
    required: "Please enter Confirm Password.",
    confirmed: "Confirm Password Doesn't matched.",
  },

  //Customer
  cust_email: {
    required: "Please enter customer email.",
    email: "Please enter correct email address",
  },

  //Good Return
  good_return_qty: {
    required: "Please enter quantity.",
    decimal: "Only numbers are allowed. e.g. 100.50 OR 100",
  },
  rate: {
    required: "Please enter rate.",
    decimal: "Only numbers are allowed. e.g. 100.50 OR 100",
  },
  totalamount: {
    required: "Please enter amount.",
    decimal: "Only numbers are allowed. e.g. 100.50 OR 100",
  },
  fgr_remarks: {
    required: "Please enter remarks.",
  },

  //Create GRN
  expirydate: {
    required: "Please select expiry date.",
  },
  invoicenumber: {
    required: "Please enter invoice number.",
    alpha_num: "Only alphabets and numbers are allowed.",
  },
  invoicedate: {
    required: "Please select invoice date.",
  },
  stockquantity: {
    required: "Please enter stock in quantity.",
    numeric: "Only numbers are allowed.",
  },
  batchnumber: {
    required: "Please enter batch number.",
    alpha_num: "Only alphabets and numbers are allowed.",
  },

  //Client Component
  client_name: {
    required: "Please enter client name.",
  },
  client_contact_person_name: {
    alpha_spaces: "Only alphabets and spaces are allowed.",
  },
  client_contact_person_email_id: {
    email: "Please enter correct email ID.",
  },
  client_contact_person_mobile_number: {
    numeric: "Only numbers are allowed.",
    min: "Please enter minimum 7 digits.",
  },

  //2FA Authentication
  secretcode: {
    required: "Please enter token.",
    numeric: "Only numbers are allowed.",
    min: "Please enter minimum 6 digits.",
    max: "Please enter maximum 6 digits.",
  },

  //SMS Template
  sms_contact_no: {
    required: "Please enter contact number.",
    numeric: "Only Numbers are allowed.",
    max: "Please enter maximum 16 numbers.",
  },
  starttime: {
    required: "Please enter Start TIme.",
  },
  endtime: {
    required: "Please enter End TIme.",
  },
  r_order: {
    required: "Please enter order.",
  },
  itemdesc: {
    required: "Please enter description of Fnb Item",
  },
  itemdesclang: {
    required: "Please enter description of Fnb Item",
  },
  itemnamelang: {
    required: "Please enter name of Fnb Item",
  },
  fnbcategorynamelang: {
    required: "Please enter name of Fnb Category",
  },
  multiplepointsrquired: {
    required: "Please enter Points Multiplier",
    decimal:
      "The  points multiplier required field must be numeric and may contain decimal points",
  },
  comment_description: {
    required: "Please enter Comment Description",
  },
  comment_name: {
    required: "Please enter Comment Name",
  },
  tax_name: {
    required: "Please Enter Tax Name",
  },
  tax_value: {
    required: "Please Enter Tax Value",
  },
  label_1: {
    required: "Please Enter label 1 details.",
  },
  label_2: {
    required: "Please Enter label 2 details.",
  },
  button_text: {
    required: "Please Enter Button Text",
  },
  voucher_enddate: {
    required: "Please Enter End Date For Voucher",
  },
  voucher_startdate: {
    required: "Please Enter Start Date For Voucher",
  },
  offer_content_title: {
    required: "Offer Title Required.",
  },
  labelname: {
    required: "Label Name Required.",
  },
  pin: {
    required: "Pin Required.",
  },
  issuer: {
    required: "Card Issuer Required.",
  },
  card_quantity: {
    required: "Quantiy Required For Multiple Cash Card.",
  },
  cash_card_reason: {
    required: "Reason Required.",
  },
  w_cash_card_name: {
    required: "Cash Card Name Required.",
  },
  w_professing_fee: {
    required: "Processing Fee Required.",
  },
  w_minimum_topup: {
    required: "Minimum Recharge Amount Required.",
  },
  w_lead_time_days: {
    required: "Lead Time is Required.",
  },
  movie_experience_name: {
    required: "Movie Expirience is Required.",
  },
  location_name: {
    required: "Location name is Required.",
  },
  pass_name: {
    required: "Pass Name is Required.",
  },
  merchandise_name: {
    required: "Name is Required.",
  },
};



// WEBPACK FOOTER //
// ./src/errorHandler/ln/en.js